"use client"

import { t } from "@/languages/i18n"
import { CalendarOutlined, CaretDownOutlined, CaretUpOutlined, EyeOutlined, KeyOutlined } from "@ant-design/icons"
import { Button, Select, Space, Typography } from "antd"
import dayjs from "dayjs"
import React, { useState } from "react"

const { Title, Text } = Typography

interface CareerPublishProps {
  onSubmit: () => void
  status: string
  setStatus: (status: string) => void
  loading?: boolean
  isEditMode?: boolean
}

const Publish: React.FC<CareerPublishProps> = ({
  onSubmit,
  status,
  setStatus,
  loading,
  isEditMode,
}) => {
  const [isVisible, setIsVisible] = useState(true)

  return (
    <div className="publish border-gray-300 border rounded-[10px] mb-5 bg-white overflow-hidden shadow-sm">
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <Title level={4} className="!m-0 text-base font-semibold">
          {t("Xuất bản")}
        </Title>
        <Button
          onClick={() => setIsVisible(!isVisible)}
          icon={isVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
          type="text"
        />
      </div>

      {isVisible && (
        <div>
          <Space direction="vertical" className="px-4 py-4 w-full" size="middle">
            <div>
              <Text className="text-sm">
                <KeyOutlined /> {t("Trạng thái")}:
                <Select
                  className="w-fit ml-2"
                  onChange={(value) => setStatus(value)}
                  options={[
                    { value: "Draft", label: t("Bản nháp") },
                    { value: "Published", label: t("Xuất bản") },
                  ]}
                  value={status}
                />
              </Text>
            </div>
            <div>
              <Text className="text-sm">
                <EyeOutlined /> {t("Hiển thị")}:
                <span className="ml-2">{status === "Published" ? t("Công khai") : t("Bản nháp")}</span>
              </Text>
            </div>
            <div>
              <Text className="text-sm">
                <CalendarOutlined /> {t("Ngày tạo")}:
                <span className="ml-2 text-xs">
                  {dayjs().format("DD/MM/YYYY HH:mm")}
                </span>
              </Text>
            </div>
          </Space>

          <div className="flex justify-end border-t pt-3 px-4 bg-[#f6f7f7] rounded-b-[10px] h-14">
            <Button 
              type="primary" 
              onClick={onSubmit} 
              loading={loading}
            >
              {status === "Draft" 
                ? t("Lưu nháp") 
                : isEditMode ? t("Cập nhật") : t("Xuất bản")
              }
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Publish